import { NgModule } from '@angular/core';
import { MsInputTextComponent } from './ms-input-text.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsInputTextComponent],
	imports: [SharedLibsModule],
	exports: [MsInputTextComponent],
	providers: [],
})
export class MsInputTextModule {}
